import { MessageSquare } from 'lucide-react';

export default function ChatWelcomePage() {
  return (
    <div className="flex flex-col items-center justify-center h-full text-center px-8">
      <div className="size-16 rounded-2xl bg-gray-100 flex items-center justify-center mb-4">
        <MessageSquare className="size-8 text-gray-400" />
      </div>
      <h2 className="text-lg font-semibold text-gray-900 mb-1">채팅할 채널을 선택하세요</h2>
      <p className="text-sm text-gray-500 max-w-sm">
        좌측 목록에서 프로젝트 채널, 그룹 채널 또는 DM을 선택하여 대화를 시작하세요.
      </p>
    </div>
  );
}
